import DeleteUserFromCompanyModal from './DeleteUserFromCompanyModal';

export default DeleteUserFromCompanyModal;
